import { render, staticRenderFns } from "./topController.vue?vue&type=template&id=a504a1ac&scoped=true"
import script from "./topController.vue?vue&type=script&lang=js"
export * from "./topController.vue?vue&type=script&lang=js"
import style0 from "./topController.vue?vue&type=style&index=0&id=a504a1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a504a1ac",
  null
  
)

export default component.exports